import { Link } from "react-router-dom";
import React from "react";
import img1 from "../mainlogo.png";
const Navbar = () => {
  return (
    <>
      <nav className="navbar navbar-expand-lg bg-black py-3">
        {/* ******************************* */}
        <div className="container">
          <Link to="/" className="Nav_img">
            <img className="logomain" src={img1} alt="" />
          </Link>

          {/* ******************************* */}
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
            <i className="fa-sharp fa-solid fa-bars-staggered"></i>
          </button>
          {/* ******************************* */}
          <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 nav_ul">
              {/* <li className="nav-item">
                <Link className="nav-link text-light" to="/about">About Us </Link>
              </li> */}
              <li className="nav-item">
                <Link className="nav-link text-light" to="/contact">Contact Us</Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link text-light" to="/blog">Blog</Link>
              </li> */}
            </ul>
            <form className="navbtn">
              <a className="nav_a1" href="https://www.facebook.com/waleedcodes" target="_blank "><i className="fa-solid fa-plus"></i>Follow</a>
              <a className="nav_a2" href="https://youtube.com/@waleedcodes?sub_confirmation=1" target="_blank "><i className="fa-brands fa-youtube align-middle"></i>Subscribe</a>
            </form>
          </div>
          {/* ******************************* */}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
